// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { OrganizationDTO } from './organization-dto';

/**
 * 
 * @export
 * @interface LandlordDTO
 */
export interface LandlordDTO {
    /**
     * 
     * @type {string}
     * @memberof LandlordDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LandlordDTO
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof LandlordDTO
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof LandlordDTO
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof LandlordDTO
     */
    type: LandlordDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LandlordDTO
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof LandlordDTO
     */
    contactNumber?: string;
    /**
     * 
     * @type {OrganizationDTO}
     * @memberof LandlordDTO
     */
    organization: OrganizationDTO;
    /**
     * 
     * @type {string}
     * @memberof LandlordDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof LandlordDTO
     */
    updatedAt: string;
}

/**
    * @export
    * @enum {string}
    */
export enum LandlordDTOTypeEnum {
    COMPANY = 'COMPANY',
    SOLEPERSON = 'SOLE_PERSON'
}



